module.exports = __webpack_public_path__ + "static/media/empty_state_menu.67457ae8.svg";